var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general"},[_c('Profile'),_c('Indexes'),_c('FriendsView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }